<div *ngIf="isKeymetrics" class="col-panel-wrapper">
    <div class="floating-col-panel" (mouseleave)="contraerColPanel()" [ngClass]="{'expanded': colPanelOpen}">
      <div class="col-panel-toggle" (mouseenter)="expandirColPanel()"><mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon></div>
      <div class="col-panel-content">
        <h6 class="col-panel-title mb-2">Columnas</h6>
        <div class="col-panel-option" *ngFor="let column of tableColumnsKey">
          <mat-checkbox [checked]="column.isShow" (change)="toggleColumnVisibility(column.id,'keymetric')" [color]="'primary'">{{column.name}}</mat-checkbox>
        </div>
      </div>
    </div>
    <cdk-virtual-scroll-viewport [tvsItemSize]="24" [headerHeight]="34" class="wrapper mat-elevation-z2" #keyMetricView>

        <table mat-table [dataSource]="keyData">
            <ng-container *ngFor="let column of tableColumnsKey">
              <ng-container matColumnDef="{{ column.id }}">
                <th mat-header-cell *matHeaderCellDef>{{ column.name | titlecase }}</th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="column.isNumber">
                        {{ element[column.id] | number:'1.2-2' }}
                    </ng-container>
                    <ng-container *ngIf="column.isString">
                        {{ element[column.id] }}
                    </ng-container>
                    <ng-container *ngIf="column.isDate">
                        {{ element[column.id] | smartDate }}
                    </ng-container>
                </td>
              </ng-container>
            </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="displayedColumnsKey; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsKey;"></tr>
          </table>
         
        
    </cdk-virtual-scroll-viewport>
</div>
<div *ngIf="isRatio" class="col-panel-wrapper">
    <div class="floating-col-panel" (mouseleave)="contraerColPanel()" [ngClass]="{'expanded': colPanelOpen}">
      <div class="col-panel-toggle" (mouseenter)="expandirColPanel()"><mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon></div>
      <div class="col-panel-content">
        <h6 class="col-panel-title mb-2">Columnas</h6>
        <div class="col-panel-option" *ngFor="let column of tableColumnsRatio">
          <mat-checkbox [checked]="column.isShow" (change)="toggleColumnVisibility(column.id,'ratio')" [color]="'primary'">{{column.name}}</mat-checkbox>
        </div>
      </div>
    </div>
    <cdk-virtual-scroll-viewport [tvsItemSize]="24" [headerHeight]="34" class="wrapper mat-elevation-z2" #viewportRatio>

        <table mat-table [dataSource]="ratioData">
            <ng-container *ngFor="let column of tableColumnsRatio">
              <ng-container matColumnDef="{{ column.id }}">
                <th mat-header-cell *matHeaderCellDef>{{ column.name | titlecase }}</th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="column.isNumber">
                        {{ element[column.id] | number:'1.2-2' }}
                    </ng-container>
                    <ng-container *ngIf="column.isString">
                        {{ element[column.id] }}
                    </ng-container>
                    <ng-container *ngIf="column.isDate">
                        {{ element[column.id] | smartDate }}
                    </ng-container>
                </td>
              </ng-container>
            </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="displayedColumnsRatio; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsRatio;"></tr>
          </table>
         
        
    </cdk-virtual-scroll-viewport>
</div>
<div *ngIf="isCashflow" class="col-panel-wrapper">
    <div class="floating-col-panel" (mouseleave)="contraerColPanel()" [ngClass]="{'expanded': colPanelOpen}">
      <div class="col-panel-toggle" (mouseenter)="expandirColPanel()"><mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon></div>
      <div class="col-panel-content">
        <h6 class="col-panel-title mb-2">Columnas</h6>
        <div class="col-panel-option" *ngFor="let column of tableColumnsCashflow">
          <mat-checkbox [checked]="column.isShow" (change)="toggleColumnVisibility(column.id,'Cashflow')" [color]="'primary'">{{column.name}}</mat-checkbox>
        </div>
      </div>
    </div>
    <cdk-virtual-scroll-viewport [tvsItemSize]="24" [headerHeight]="34" class="wrapper mat-elevation-z2" #viewportCashflow>

        <table mat-table [dataSource]="CashflowData">
            <ng-container *ngFor="let column of tableColumnsCashflow">
              <ng-container matColumnDef="{{ column.id }}">
                <th mat-header-cell *matHeaderCellDef>{{ column.name | titlecase }}</th>
                <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="column.isNumber">
                        {{ element[column.id] | number:'1.2-2' }}
                    </ng-container>
                    <ng-container *ngIf="column.isString">
                        {{ element[column.id] }}
                    </ng-container>
                    <ng-container *ngIf="column.isDate">
                        {{ element[column.id] | smartDate }}
                    </ng-container>
                </td>
              </ng-container>
            </ng-container>
          
            <tr mat-header-row *matHeaderRowDef="displayedColumnsCashflow; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsCashflow;"></tr>
          </table>
         
        
    </cdk-virtual-scroll-viewport>
</div>
<div *ngIf="isIncomeGrowth" class="col-panel-wrapper">
  <div class="floating-col-panel" (mouseleave)="contraerColPanel()" [ngClass]="{'expanded': colPanelOpen}">
    <div class="col-panel-toggle" (mouseenter)="expandirColPanel()"><mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon></div>
    <div class="col-panel-content">
      <h6 class="col-panel-title mb-2">Columnas</h6>
      <div class="col-panel-option" *ngFor="let column of tableColumnsIncomeGrowth">
        <mat-checkbox [checked]="column.isShow" (change)="toggleColumnVisibility(column.id,'IncomeGrowth')" [color]="'primary'">{{column.name}}</mat-checkbox>
      </div>
    </div>
  </div>
  <cdk-virtual-scroll-viewport [tvsItemSize]="24" [headerHeight]="34" class="wrapper mat-elevation-z2" #viewportIncomeGrowth>

      <table mat-table [dataSource]="IncomeGrowthData">
          <ng-container *ngFor="let column of tableColumnsIncomeGrowth">
            <ng-container matColumnDef="{{ column.id }}">
              <th mat-header-cell *matHeaderCellDef>{{ column.name | titlecase }}</th>
              <td mat-cell *matCellDef="let element">
                  <ng-container *ngIf="column.isNumber">
                      {{ element[column.id] | number:'1.2-2' }}
                  </ng-container>
                  <ng-container *ngIf="column.isString">
                      {{ element[column.id] }}
                  </ng-container>
                  <ng-container *ngIf="column.isDate">
                      {{ element[column.id] | smartDate }}
                  </ng-container>
              </td>
            </ng-container>
          </ng-container>
        
          <tr mat-header-row *matHeaderRowDef="displayedColumnsIncomeGrowth; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsIncomeGrowth;"></tr>
        </table>
       
      
  </cdk-virtual-scroll-viewport>
</div>
<div *ngIf="isBalanceSheetGrowth" class="col-panel-wrapper">
  <div class="floating-col-panel" (mouseleave)="contraerColPanel()" [ngClass]="{'expanded': colPanelOpen}">
    <div class="col-panel-toggle" (mouseenter)="expandirColPanel()"><mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon></div>
    <div class="col-panel-content">
      <h6 class="col-panel-title mb-2">Columnas</h6>
      <div class="col-panel-option" *ngFor="let column of tableColumnsBalanceSheetGrowth">
        <mat-checkbox [checked]="column.isShow" (change)="toggleColumnVisibility(column.id,'BalanceSheetGrowth')" [color]="'primary'">{{column.name}}</mat-checkbox>
      </div>
    </div>
  </div>
  <cdk-virtual-scroll-viewport [tvsItemSize]="24" [headerHeight]="34" class="wrapper mat-elevation-z2" #viewportBalanceSheetGrowth>

      <table mat-table [dataSource]="BalanceSheetGrowthData">
          <ng-container *ngFor="let column of tableColumnsBalanceSheetGrowth">
            <ng-container matColumnDef="{{ column.id }}">
              <th mat-header-cell *matHeaderCellDef>{{ column.name | titlecase }}</th>
              <td mat-cell *matCellDef="let element">
                  <ng-container *ngIf="column.isNumber">
                      {{ element[column.id] | number:'1.2-2' }}
                  </ng-container>
                  <ng-container *ngIf="column.isString">
                      {{ element[column.id] }}
                  </ng-container>
                  <ng-container *ngIf="column.isDate">
                      {{ element[column.id] | smartDate }}
                  </ng-container>
              </td>
            </ng-container>
          </ng-container>
        
          <tr mat-header-row *matHeaderRowDef="displayedColumnsBalanceSheetGrowth; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsBalanceSheetGrowth;"></tr>
        </table>
       
      
  </cdk-virtual-scroll-viewport>
</div>
<div *ngIf="isFinancialGrowth" class="col-panel-wrapper">
  <div class="floating-col-panel" (mouseleave)="contraerColPanel()" [ngClass]="{'expanded': colPanelOpen}">
    <div class="col-panel-toggle" (mouseenter)="expandirColPanel()"><mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon></div>
    <div class="col-panel-content">
      <h6 class="col-panel-title mb-2">Columnas</h6>
      <div class="col-panel-option" *ngFor="let column of tableColumnsFinancialGrowth">
        <mat-checkbox [checked]="column.isShow" (change)="toggleColumnVisibility(column.id,'FinancialGrowth')" [color]="'primary'">{{column.name}}</mat-checkbox>
      </div>
    </div>
  </div>
  <cdk-virtual-scroll-viewport [tvsItemSize]="24" [headerHeight]="34" class="wrapper mat-elevation-z2" #viewportFinancialGrowth>

      <table mat-table [dataSource]="FinancialGrowthData">
          <ng-container *ngFor="let column of tableColumnsFinancialGrowth">
            <ng-container matColumnDef="{{ column.id }}">
              <th mat-header-cell *matHeaderCellDef>{{ column.name | titlecase }}</th>
              <td mat-cell *matCellDef="let element">
                  <ng-container *ngIf="column.isNumber">
                      {{ element[column.id] | number:'1.2-2' }}
                  </ng-container>
                  <ng-container *ngIf="column.isString">
                      {{ element[column.id] }}
                  </ng-container>
                  <ng-container *ngIf="column.isDate">
                      {{ element[column.id] | smartDate }}
                  </ng-container>
              </td>
            </ng-container>
          </ng-container>
        
          <tr mat-header-row *matHeaderRowDef="displayedColumnsFinancialGrowth; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsFinancialGrowth;"></tr>
        </table>
       
      
  </cdk-virtual-scroll-viewport>
</div>
<div *ngIf="isOwnerEarnings" class="col-panel-wrapper">
  <div class="floating-col-panel" (mouseleave)="contraerColPanel()" [ngClass]="{'expanded': colPanelOpen}">
    <div class="col-panel-toggle" (mouseenter)="expandirColPanel()"><mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon></div>
    <div class="col-panel-content">
      <h6 class="col-panel-title mb-2">Columnas</h6>
      <div class="col-panel-option" *ngFor="let column of tableColumnsOwnerEarnings">
        <mat-checkbox [checked]="column.isShow" (change)="toggleColumnVisibility(column.id,'OwnerEarnings')" [color]="'primary'">{{column.name}}</mat-checkbox>
      </div>
    </div>
  </div>
  <cdk-virtual-scroll-viewport [tvsItemSize]="24" [headerHeight]="34" class="wrapper mat-elevation-z2" #viewportFinancialScore>

      <table mat-table [dataSource]="OwnerEarningsData">
          <ng-container *ngFor="let column of tableColumnsOwnerEarnings">
            <ng-container matColumnDef="{{ column.id }}">
              <th mat-header-cell *matHeaderCellDef>{{ column.name | titlecase }}</th>
              <td mat-cell *matCellDef="let element">
                  <ng-container *ngIf="column.isNumber">
                      {{ element[column.id] | number:'1.2-2' }}
                  </ng-container>
                  <ng-container *ngIf="column.isString">
                      {{ element[column.id] }}
                  </ng-container>
                  <ng-container *ngIf="column.isDate">
                      {{ element[column.id] | smartDate }}
                  </ng-container>
              </td>
            </ng-container>
          </ng-container>
        
          <tr mat-header-row *matHeaderRowDef="displayedColumnsOwnerEarnings; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsOwnerEarnings;"></tr>
        </table>
       
      
  </cdk-virtual-scroll-viewport>
</div>
<!-- EnterpriseValues -->
<div *ngIf="isEnterpriseValues" class="col-panel-wrapper">
  <div class="floating-col-panel" (mouseleave)="contraerColPanel()" [ngClass]="{'expanded': colPanelOpen}">
    <div class="col-panel-toggle" (mouseenter)="expandirColPanel()"><mat-icon>{{colPanelOpen ? 'chevron_left' : 'view_column'}}</mat-icon></div>
    <div class="col-panel-content">
      <h6 class="col-panel-title mb-2">Columnas</h6>
      <div class="col-panel-option" *ngFor="let column of tableColumnsEnterpriseValues">
        <mat-checkbox [checked]="column.isShow" (change)="toggleColumnVisibility(column.id,'EnterpriseValues')" [color]="'primary'">{{column.name}}</mat-checkbox>
      </div>
    </div>
  </div>
  <cdk-virtual-scroll-viewport [tvsItemSize]="24" [headerHeight]="34" class="wrapper mat-elevation-z2" #viewportEnterpriseValues>

      <table mat-table [dataSource]="EnterpriseValuesData">
          <ng-container *ngFor="let column of tableColumnsEnterpriseValues">
            <ng-container matColumnDef="{{ column.id }}">
              <th mat-header-cell *matHeaderCellDef>{{ column.name | titlecase }}</th>
              <td mat-cell *matCellDef="let element">
                  <ng-container *ngIf="column.isNumber">
                      {{ element[column.id] | number:'1.2-2' }}
                  </ng-container>
                  <ng-container *ngIf="column.isString">
                      {{ element[column.id] }}
                  </ng-container>
                  <ng-container *ngIf="column.isDate">
                      {{ element[column.id] | smartDate }}
                  </ng-container>
              </td>
            </ng-container>
          </ng-container>
        
          <tr mat-header-row *matHeaderRowDef="displayedColumnsEnterpriseValues; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsEnterpriseValues;"></tr>
        </table>
       
      
  </cdk-virtual-scroll-viewport>
</div>